export const styles = {
  pageHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },

  pageTitle: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    margin: "0 0 8px 0",
  },

  pageSubtitle: {
    margin: 0,
    color: "#6c757d",
    fontSize: "14px",
  },

  tabsContainer: {
    borderBottom: 1,
    borderColor: "divider",
  },

  tabItem: {
    minHeight: 48,
  },

  packagesContent: {
    paddingTop: 0,
    paddingBottom: "2rem",
  },

  searchFilters: {
    display: "flex",
    gap: 2,
    mb: 3,
    mt: 3,
    alignItems: "center",
  },

  searchField: {
    minWidth: 300,
  },

  statusFilter: {
    minWidth: 150,
  },

  packagesGrid: {
    mb: 3,
  },

  packageCard: {
    height: "100%",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: 4,
      borderColor: "primary.main",
    },
  },

  activePackageCard: {
    border: "2px solid #4caf50",
  },

  inactivePackageCard: {
    border: "1px solid #e0e0e0",
  },

  packageCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 2,
  },

  packageCardTitle: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  packageDescription: {
    mb: 2,
  },

  packageDetails: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },

  packageDetail: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  packageActions: {
    justifyContent: "space-between",
    px: 2,
    pb: 2,
  },

  packageActionButton: {
    minWidth: { xs: "auto", sm: "auto" },
    px: { xs: 1, sm: 2 },
  },

  noPackagesContainer: {
    textAlign: "center",
    py: 8,
    bgcolor: "grey.50",
    borderRadius: 2,
    border: "2px dashed #bdbdbd",
  },

  noPackagesIcon: {
    fontSize: 64,
    color: "grey.400",
    mb: 2,
  },

  layoutContainer: {
    minHeight: "100vh",
    bgcolor: "#f8f9fa",
  },

  permissionsCard: {
    mb: 3,
  },

  permissionsTitle: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  permissionsDescription: {
    mb: 3,
  },

  permissionsTableContainer: {
    overflowX: "auto",
  },

  permissionsActions: {
    mt: 3,
    display: "flex",
    gap: 2,
  },

  permissionsButton: {
    px: 3,
    py: 1.5,
  },

  analyticsCard: {
    mb: 3,
  },

  chartPlaceholder: {
    height: 300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "grey.50",
    borderRadius: 1,
  },

  metricsGrid: {
    mb: 2,
  },

  metricBox: {
    textAlign: "center",
    p: 2,
    borderRadius: 1,
  },

  primaryMetric: {
    bgcolor: "primary.light",
  },

  successMetric: {
    bgcolor: "success.light",
  },

  warningMetric: {
    bgcolor: "warning.light",
  },

  infoMetric: {
    bgcolor: "info.light",
  },

  metricValue: {
    fontWeight: 600,
  },

  metricLabel: {
    fontSize: "0.75rem",
  },

  statsPlaceholder: {
    height: 200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "grey.50",
    borderRadius: 1,
  },

  processingActions: {
    display: "flex",
    gap: 2,
    flexWrap: "wrap",
  },

  processingButton: {
    px: 3,
    py: 1.5,
  },

  processingResults: {
    height: 300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "grey.50",
    borderRadius: 1,
    border: "2px dashed #bdbdbd",
  },

  processingResultsContent: {
    textAlign: "center",
  },

  processingResultsIcon: {
    fontSize: 48,
    color: "grey.400",
    mb: 2,
  },

  fab: {
    position: "fixed",
    bottom: 24,
    right: 24,
    zIndex: 1000,
  },

  dialogContent: {
    display: "flex",
    gap: 2,
    mt: 2,
  },

  dialogPriceField: {
    flex: 1,
  },

  dialogCurrencyField: {
    minWidth: 100,
  },
} as const;
